import { ProductCode } from '../types';
import { ServiceStatus } from '../types';
import { useServiceStatusInfo } from './useServiceStatusInfo';

export function useCtaasServiceStatus() {
  const { data: serviceStatusInfos = [] } = useServiceStatusInfo();

  const serviceStatusInfo = serviceStatusInfos.find(
    (info) => info.product.code === ProductCode.CTS_BST
  );

  return serviceStatusInfo?.status ?? ServiceStatus.NotActivated;
}
